import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import type { AuditData } from '@eye-able/types';

export function useFetchAuditEntriesByIds(
  ids: number[],
  refreshOnMount = false,
) {
  const sortedIds = Array.from(new Set(ids)).sort((a, b) => a - b);

  return useQuery({
    enabled: sortedIds.length > 0,
    queryKey: [api.auditEntriesLookup, 'ids', sortedIds],
    queryFn: () =>
      fetchWrapper.post<AuditData[]>(api.auditEntriesLookup, {
        ids: sortedIds,
      }),
    staleTime: refreshOnMount ? 0 : undefined,
    refetchOnMount: refreshOnMount ? 'always' : undefined,
  });
}
